// Campus photo for /colleges/kent-state-university: CC BY-SA 4.0, by JonRidinger, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AKent_Hall_2015_front.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/kent-state-university/; credited under the photo.
const photo = {
    "slug": "kent-state-university",
    "alt": "Kent Hall and its columned entrance on the Kent Campus of Kent State University in Kent, Ohio",
    "src": "/colleges/kent-state-university/campus-1600.webp",
    "srcSmall": "/colleges/kent-state-university/campus-800.webp",
    "srcMid": "/colleges/kent-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/kent-state-university/og.jpg",
    "title": "Kent Hall 2015 front",
    "author": "JonRidinger",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AKent_Hall_2015_front.jpg",
    "read": "2026-10-01"
};

export default photo;
